import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsCollectorsViewRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-collectors-view',
	path: '/secure/ViewCollector([!%]?[\\w]*).jspa',
	query: ['projectKey'],
};
